import React from 'react';
import styled from 'styled-components';
import { space, layout, typography, color, position } from 'styled-system';
import Text, { TextProps } from './Text';

type PProps = Omit<TextProps, 'tag'> & { tag?: 'p' };

const StyledP: React.FC<PProps> = ({ children, tag = 'p', ...otherProps }) => (
    <Text tag={tag} {...otherProps}>
        {children}
    </Text>
);

const P = styled(StyledP)`
    ${space}
    ${layout}
  ${typography}
  ${color}
  ${position}
`;

P.displayName = 'P';
export default P;
